import React from "react";
import { all_routes } from "../../router/all_routes";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { Link } from "react-router-dom";
import StudentSidebar from "../common/studentSidebar";
import ProfileCard from "../common/profileCard";
import { useTranslation } from "react-i18next";

const StudentCertificates = () => {
  const route = all_routes;
  const { t } = useTranslation();

  return (
    <>
      <div className="content">
        <div className="container">
          {/* Profile */}
          <ProfileCard />
          {/* /Profile */}
          <div className="row">
            {/* Sidebar */}
            <StudentSidebar />
            {/* sidebar */}
            <div className="col-lg-9">
              <Breadcrumb title={t("certificates.title")} />
              <div className="page-title d-flex align-items-center justify-content-between">
                <h5>{t("certificates.title")}</h5>
              </div>
              <div className="table-responsive custom-table">
                <table className="table">
                  <thead className="thead-light">
                    <tr>
                      <th>{t("certificates.id")}</th>
                      <th>{t("certificates.name")}</th>
                      <th>{t("certificates.date")}</th>
                      <th>{t("certificates.marks")}</th>
                      <th>{t("certificates.outOf")}</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>01</td>
                      <td>
                        <Link to="#" className="fw-semibold">
                          UI/UX Design Certificate
                        </Link>
                      </td>
                      <td>22 Aug 2025</td>
                      <td>20</td>
                      <td>20</td>
                      <td>
                        <div className="d-flex align-items-center">
                          <Link
                            to="#"
                            className="d-inline-flex fs-14 me-1 action-icon"
                            data-bs-toggle="modal"
                            data-bs-target="#view_certificate"
                          >
                            <i className="isax isax-eye" />
                          </Link>
                          <Link
                            to="#"
                            className="d-inline-flex fs-14 action-icon"
                          >
                            <i className="isax isax-import" />
                          </Link>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>02</td>
                      <td>
                        <Link to="#" className="fw-semibold">
                          Wordpress Certificate
                        </Link>
                      </td>
                      <td>10 Aug 2025</td>
                      <td>18</td>
                      <td>20</td>
                      <td>
                        <div className="d-flex align-items-center">
                          <Link
                            to="#"
                            className="d-inline-flex fs-14 me-1 action-icon"
                            data-bs-toggle="modal"
                            data-bs-target="#view_certificate"
                          >
                            <i className="isax isax-eye" />
                          </Link>
                          <Link
                            to="#"
                            className="d-inline-flex fs-14 action-icon"
                          >
                            <i className="isax isax-import" />
                          </Link>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>03</td>
                      <td>
                        <Link to="#" className="fw-semibold">
                          HTML CSS Certificate
                        </Link>
                      </td>
                      <td>26 Jul 2025</td>
                      <td>25</td>
                      <td>30</td>
                      <td>
                        <div className="d-flex align-items-center">
                          <Link
                            to="#"
                            className="d-inline-flex fs-14 me-1 action-icon"
                            data-bs-toggle="modal"
                            data-bs-target="#view_certificate"
                          >
                            <i className="isax isax-eye" />
                          </Link>
                          <Link
                            to="#"
                            className="d-inline-flex fs-14 action-icon"
                          >
                            <i className="isax isax-import" />
                          </Link>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>04</td>
                      <td>
                        <Link to="#" className="fw-semibold">
                          JavaScript Certificate
                        </Link>
                      </td>
                      <td>14 Jul 2025</td>
                      <td>15</td>
                      <td>20</td>
                      <td>
                        <div className="d-flex align-items-center">
                          <Link
                            to="#"
                            className="d-inline-flex fs-14 me-1 action-icon"
                            data-bs-toggle="modal"
                            data-bs-target="#view_certificate"
                          >
                            <i className="isax isax-eye" />
                          </Link>
                          <Link
                            to="#"
                            className="d-inline-flex fs-14 action-icon"
                          >
                            <i className="isax isax-import" />
                          </Link>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>05</td>
                      <td>
                        <Link to="#" className="fw-semibold">
                          Photoshop Certificate
                        </Link>
                      </td>
                      <td>19 Jun 2025</td>
                      <td>20</td>
                      <td>30</td>
                      <td>
                        <div className="d-flex align-items-center">
                          <Link
                            to="#"
                            className="d-inline-flex fs-14 me-1 action-icon"
                            data-bs-toggle="modal"
                            data-bs-target="#view_certificate"
                          >
                            <i className="isax isax-eye" />
                          </Link>
                          <Link
                            to="#"
                            className="d-inline-flex fs-14 action-icon"
                          >
                            <i className="isax isax-import" />
                          </Link>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>06</td>
                      <td>
                        <Link to="#" className="fw-semibold">
                          Python Certificate
                        </Link>
                      </td>
                      <td>12 Jun 2025</td>
                      <td>20</td>
                      <td>20</td>
                      <td>
                        <div className="d-flex align-items-center">
                          <Link
                            to="#"
                            className="d-inline-flex fs-14 me-1 action-icon"
                            data-bs-toggle="modal"
                            data-bs-target="#view_certificate"
                          >
                            <i className="isax isax-eye" />
                          </Link>
                          <Link
                            to="#"
                            className="d-inline-flex fs-14 action-icon"
                          >
                            <i className="isax isax-import" />
                          </Link>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* View Certificate */}
      <div className="modal fade" id="view_certificate">
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5>{t("certificates.view")}</h5>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="isax isax-close-circle5" />
              </button>
            </div>
            <div className="modal-body">
              <div>
                <ImageWithBasePath
                  src="assets/img/icon/certificate.svg"
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="text-end mt-4">
                <Link to="#" className="btn btn-secondary rounded-pill">
                  <i className="isax isax-import me-2" />
                  {t("certificates.download")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /View Certificate */}
    </>
  );
};

export default StudentCertificates;
